export const handleResponse = (response) => {
  if (!response.ok) {
    return {
      error: response.status
    };
  }
  return response.json();
}